// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__INsDS","time":"styles_time__22EX7"};